import { createSlice } from '@reduxjs/toolkit'
import * as Sentry from '@sentry/react'

export const authenticationSlice = createSlice({
  name: 'authentication',
  initialState: {
    user: null,
    token: null,
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload
      Sentry.setUser({ id: action.payload.id })
    },
    setToken: (state, action) => {
      state.token = action.payload
      if (action.payload) {
        Sentry.setUser({ id: action.payload.id })
      }
    },
    clearToken: (state) => {
      state.token = null
      state.user = null
    },
  },
})

export const { setUser, setToken, clearToken } = authenticationSlice.actions

export default authenticationSlice.reducer

export const selectUser = (state) => state.authentication.user
export const selectToken = (state) => state.authentication.token
